import styled from"@emotion/styled";import{Form,FormItem}from"@wp/src/components/common/form";export const StyledForm=styled(Form)``;const StyledFormItem=styled(FormItem)`
  .ant-form-item-label {
    padding: 0;
    & > label {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;

      color: ${props=>props.theme.colors.neutral800};
    }
  }

  .ant-form-item-control {
    width: 100%;
  }
`;export const AmountFormItem=styled(StyledFormItem)`
  width: 100%;
  margin-bottom: 10px;
`;